import { StripeAutopayPanel } from '@/components/StripeAutopayPanel';

/**
 * /autopay — rental autopay on the Stripe rail.
 * (The Bill & Pay bridge panel and the legacy QBO-direct method/enrollment
 * UI were removed 2026-08-12 — Stripe is the only payment rail.)
 */
export default function Autopay() {
  return (
    <div className="h-full overflow-y-auto scrollbar-thin pb-16 md:pb-10">
      <div className="px-6 md:px-8 pt-8 pb-12 max-w-2xl mx-auto">
        <h1 className="mb-4 text-center font-display text-2xl font-bold tracking-tight text-brix-ink">
          Autopay
        </h1>
        <p className="text-center text-base mb-7 text-brix-muted max-w-xl mx-auto">
          Tell us how each part of your account gets paid. Put it on autopay and we'll charge your
          saved card or bank when each invoice is issued — or say you'll mail checks or send us ACH,
          and we'll leave it to you.
        </p>

        <StripeAutopayPanel />
      </div>
    </div>
  );
}
